"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _RightForward = _interopRequireDefault(require("@cx/couturier/icons/utils/RightForward"));

var _LeftBack = _interopRequireDefault(require("@cx/couturier/icons/utils/LeftBack"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);
    _this.handleNext = _this.handleNext.bind(_assertThisInitialized(_this));
    _this.handlePrevious = _this.handlePrevious.bind(_assertThisInitialized(_this));
    _this.slider = _react.default.createRef();
    return _this;
  }

  _createClass(Carousel, [{
    key: "handleNext",
    value: function handleNext() {
      this.slider.current.slickNext();
    }
  }, {
    key: "handlePrevious",
    value: function handlePrevious() {
      this.slider.current.slickPrev();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          initialSlide = _this$props.initialSlide,
          otherProps = _objectWithoutProperties(_this$props, ["children", "className", "initialSlide"]);

      var appendDots = function appendDots(dots) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "Carousel-navigation"
        }, /*#__PURE__*/_react.default.createElement("ul", {
          className: "Carousel-dots"
        }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
          "aria-label": "previous-item",
          className: "Carousel-previous",
          onClick: _this2.handlePrevious
        }, /*#__PURE__*/_react.default.createElement(_LeftBack.default, null))), dots.map(function (dot) {
          return _react.default.cloneElement(dot, {
            'aria-label': 'slide button'
          });
        }), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
          "aria-label": "next-item",
          className: "Carousel-next",
          onClick: _this2.handleNext
        }, /*#__PURE__*/_react.default.createElement(_RightForward.default, null)))));
      };

      var slickSettings = {
        appendDots: appendDots,
        accessibility: true,
        arrows: false,
        dots: true,
        infinite: true,
        ref: this.slider,
        slidesToShow: 1,
        initialSlide: (0, _utils.isValidSlide)(initialSlide, children.length) ? initialSlide : 0
      };
      return /*#__PURE__*/_react.default.createElement(_reactSlick.default, _extends({
        className: "Carousel ".concat(className || '')
      }, slickSettings, otherProps), children);
    }
  }]);

  return Carousel;
}(_react.default.Component);

Carousel.defaultProps = {
  className: '',
  initialSlide: 0
};
var _default = Carousel;
exports.default = _default;